<template>
   <v-container fluid> 
       <v-row>
           <v-col cols="6">
            <h2>{{survey.title}}
            <v-chip class="ma-2" :color="statusColor" text-color="white">{{statusText}}</v-chip></h2>
            <p>{{survey.description}}</p>
            <p>{{ $t('wkt.admin.assessments.tab.summary.start-date') }} {{formatDate(survey.publishStartDate)}}</p>
            <p>{{ $t('wkt.admin.assessments.tab.summary.end-date') }} {{formatDate(survey.publishEndDate)}}</p>
            <p>{{ $t('wkt.admin.assessments.tab.summary.responses-received') }} {{survey.currentResponses}}/{{survey.expectedResponses}}</p>
           </v-col>
           <v-col cols="6" v-show="!loading">
               <div v-if="survey.currentResponses==0"
                    style="width: 240px; color:#0000005e; text-align: center;" class="mx-auto">
                    <v-icon style="font-size:15em; color:#0000002e" >local_printshop</v-icon>
                    <span style="font-size:1.6em;width: 220px;">{{ $t('wkt.admin.common.assessments.no-results') }}</span>
                </div>
                <GChart v-if="survey.currentResponses>0"
                    type="PieChart"
                    :data="totalResponsesData"
                    :options="totalResponsesOptions"
                />
           </v-col>   
        </v-row>
    <v-row v-if="survey.currentResponses>0">
        <v-col cols="12" v-show="!loading">
            <GChart
                    type="ColumnChart"
                    :data="chartData"
                    :options="chartOptions"
                />
         </v-col>
  </v-row>
    </v-container>
</template>

<script> 

import { GChart } from 'vue-google-charts'

export default {
  name: 'SurveySummary',
  props: {
      surveyData: null,
      submissionData: null,
  },
  components: {
    GChart
  },
  
  data() {
      return {
          loading: true,
          statusText: '',
          statusColor: 'white',
          survey: {
              title: null,
              description: null
          },
          submission: [],
          chartData: [],
            chartOptions: {
                legend: {position: 'none'},
                chart: {
                    hAxis: {
                        format: 'd/m/yy'
                    },
                }
            },
            totalResponsesData: [
            ],
            totalResponsesOptions: {
                pieHole: 0.2,
                chart: {
                    
                }
            },
      }
  },
  watch: {
    submissionData: function() { 
        this.refresh(this.surveyData, this.submissionData);
    }
  },
   methods: {
    refresh(survey,submissionInfo) { 
        this.survey = survey;
        this.submissions = submissionInfo.submissions;
        this.loading = true;

        let now = new Date().getTime();
        if (this.survey.enabled==0) {
            this.statusText = this.$t('wkt.admin.assessments.tab.summary.disable-status'); // "Deshabilitada";
            this.statusColor= '#F44336';
        }
        else 
        if (this.survey.enabled==1 && this.survey.publishStartDate<now && (!this.survey.publishEndDate || this.survey.publishEndDate>now)) {
            this.statusText = this.$t('wkt.admin.assessments.tab.summary.open-status'); // "Abierta";
            this.statusColor= '#43a047';
        } else {
            this.statusText = this.$t('wkt.admin.assessments.tab.summary.close-status'); // "Cerrada";
            this.statusColor= '#f57c00';
        }
        this.totalResponsesData =  [
                ['Option', 'Responses'],
                [this.$t('wkt.admin.assessments.tab.summary.answered'), this.survey.currentResponses],
                [this.$t('wkt.admin.assessments.tab.summary.without-answer'), this.survey.expectedResponses],
            ]; 

        this.chartData = this.buildStats(this.survey, this.submissions);
        this.loading = false;
    },
    buildStats (survey, submissions) {
        
        let endDate = survey.publishEndDate?survey.publishEndDate:this.getMaxDate(submissions);

        let days = Math.round((endDate-survey.publishStartDate)/(1000*60*60*24));
        let stats = new Map();

        for (let d=0;d<days;d++)
        {
            let current = new Date (survey.publishStartDate + d * 1000*60*60*24);
            stats.set(this.formatDate(current),0);
        }

        for (let submission of submissions) {
            let sdate = this.formatDate(submission.updateDate);
            if (stats.has(sdate))
                stats.set(sdate,stats.get(sdate)+1);
        }

        let chartStats = [['Fecha', 'Respuestas']];

        stats.forEach ( function (v,k) {
                chartStats.push([k,v]);
        });
       
       return chartStats;

    },
    getMaxDate (submissions) {
        let maxDate = new Date().getTime();
        for (let submission of submissions) {
            if (maxDate<submission.updateDate) {
                maxDate=submission.updateDate;
            }
        } 
        return maxDate;
    },
    formatDate (value) {
        return !value ? '' : new Date(value).toLocaleDateString();
    },
   }
};
</script>
